(() => {

  const WIM_FORMS_VERSION = 'v42';

  const POLL_MS = 500;
  const MAX_POLL_ATTEMPTS = 80; // ~40s
  const MOTIVO_RETRY_MS = 250;
  const MOTIVO_MAX_TRIES = 120; // ~30s

  // Helpers (para no repetir patterns)
  const qsa = (root, sel) => Array.prototype.slice.call(root.querySelectorAll(sel));
  const normText = (s) => (s || '').replace(/\s+/g, ' ').trim();

  // Encontrar el embed (host del shadow).
  function getFormsHost(appRoot) {
    return (
      (appRoot && appRoot.querySelector && appRoot.querySelector('shopify-forms-embed')) ||
      document.querySelector('shopify-forms-embed')
    );
  }

  /**
   * @param {ParentNode} target Dónde inyectar (shadowRoot o app root si aún no existe shadow)
   * @param {ParentNode | null} legacyHost Si luego pasamos a shadow, borrar <style> viejo del host anterior (appRoot)
   */
  // Inyectar/actualizar el <style> del skin dentro del shadow.
  function ensureSkinStyles(target, legacyHost) {
    if (!target) return;

    if (legacyHost && legacyHost !== target) {
      Array.prototype.slice.call(legacyHost.querySelectorAll('style[data-wim-forms-skin]')).forEach((st) => {
        if (st && st.parentNode) st.parentNode.removeChild(st);
      });
    }

    const existing = target.querySelector('style[data-wim-forms-skin]');
    const style = existing || document.createElement('style');
    style.setAttribute('data-wim-forms-skin', 'true');
    style.setAttribute('data-wim-forms-skin-version', WIM_FORMS_VERSION);
    style.textContent = `
      :host, * { font-family: inherit; }

      [class*="formContainer" i],
      [class*="formWrapper" i],
      [class*="formRoot" i],
      [class*="formInner" i],
      [class*="container" i][data-testid="form-wrapper"] {
        width: 100% !important;
        max-width: 100% !important;
        margin-left: 0 !important;
        margin-right: 0 !important;
      }

      [data-wim-field] { min-width: 0; }
      [data-wim-span="2"] { grid-column: 1 / -1; }

      
      @media (min-width: 768px) {
        :host form[data-testid="form"],
        form[data-testid="form"],
        form[data-testid="form"][class*="formFieldset" i],
        form[data-testid="form"][class*="_formFieldset" i] {
          display: flex !important;
          flex-direction: row !important;
          flex-wrap: wrap !important;
          column-gap: 2.4rem !important;
          row-gap: 2rem !important;
        }

        :host form[data-testid="form"] > *,
        form[data-testid="form"] > * {
          flex: 1 1 100% !important;
          min-width: 0 !important;
        }

        :host form[data-testid="form"] > button[type="submit"],
        :host form[data-testid="form"] > input[type="submit"],
        :host form[data-testid="form"] > [type="submit"],
        form[data-testid="form"] > button[type="submit"],
        form[data-testid="form"] > input[type="submit"],
        form[data-testid="form"] > [type="submit"] {
          flex: 0 0 auto !important;
          min-width: 0 !important;
        }

        :host form[data-testid="form"] > [data-wim-field="field-first_name"],
        :host form[data-testid="form"] > [data-wim-field="field-last_name"],
        :host form[data-testid="form"] > [data-wim-field="field-email"],
        :host form[data-testid="form"] > [data-wim-phone-container="true"],
        form[data-testid="form"] > [data-wim-field="field-first_name"],
        form[data-testid="form"] > [data-wim-field="field-last_name"],
        form[data-testid="form"] > [data-wim-field="field-email"],
        form[data-testid="form"] > [data-wim-phone-container="true"] {
          flex: 1 1 calc(50% - 1.2rem) !important;
          min-width: 0 !important;
          width: auto !important;
        }
      }

      .wim-forms-field,
      [class*="formFieldContainer" i],
      [data-wim-field] {
        display: flex;
        flex-direction: column;
        gap: .6rem;
        align-items: stretch;
        height: auto !important;
        min-height: 0 !important;
        overflow: visible !important;
      }

      .wim-forms-field::before,
      [class*="formFieldContainer" i]::before,
      [data-wim-field]::before {
        content: none !important;
        display: none !important;
      }

      label, [class*="label" i] {
        font-size: var(--wim-font-size-paragraph-sm);
        color: var(--wim-color-black-grey);
        font-weight: var(--wim-font-weight-bold);
        display: flex !important; /* keep checkbox aligned with text */
      }

      .wim-forms-field > label,
      [class*="formFieldContainer" i] > label {
        display: block !important;
        font-size: var(--wim-font-size-paragraph-sm) !important;
        color: var(--wim-color-black-grey) !important;
        font-weight: var(--wim-font-weight-bold) !important;
        opacity: 1 !important;
      }

      /* Floating labels -> static label above input */
      .wim-forms-label,
      [class*="_formInputFieldLabel" i],
      [class*="formInputFieldLabel" i] {
        position: static !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        transform: none !important;
        margin: 0 0 .6rem 0 !important;
        padding: 0 !important;
        height: auto !important;
        line-height: 1.2 !important;
        pointer-events: auto !important;
        opacity: 1 !important;
        background: transparent !important;
        z-index: auto !important;
      }

      .wim-forms-field input,
      .wim-forms-field textarea,
      .wim-forms-field button,
      .wim-forms-field select,
      [class*="formFieldContainer" i] input,
      [class*="formFieldContainer" i] textarea,
      [class*="formFieldContainer" i] button,
      [class*="formFieldContainer" i] select,
      [data-wim-field] input,
      [data-wim-field] textarea,
      [data-wim-field] button,
      [data-wim-field] select {
        order: 1;
      }
      .wim-forms-field label,
      [class*="formFieldContainer" i] label,
      [data-wim-field] label {
        order: 0;
      }

      .wim-forms-label {
        display: block;
        margin-bottom: .6rem;
      }

      input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]),
      textarea,
      select {
        outline: none !important;
        box-shadow: none !important;
        font-size: var(--wim-font-size-paragraph-md);
        color: var(--wim-color-black-grey) !important;
        background-color: rgba(var(--color-field), var(--color-field-alpha, 1)) !important;
        border: var(--inputs-border-width) solid rgba(var(--color-border), var(--color-border-alpha, 1)) !important;
        border-radius: var(--inputs-radius) !important;
        line-height: calc(var(--buttons-height) - var(--inputs-border-width, 0px) * 2) !important;
        padding: 0 2rem !important;
        padding-top: 0 !important;
        box-sizing: border-box !important;
        width: 100% !important;
      }

      input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):focus,
      textarea:focus,
      select:focus {
        outline: none !important;
        box-shadow: none !important;
      }


      [class*="selectContainer" i] {
        outline: none !important;
        box-shadow: none !important;
        background-color: rgba(var(--color-field), var(--color-field-alpha, 1)) !important;
        border: var(--inputs-border-width) solid rgba(var(--color-border), var(--color-border-alpha, 1)) !important;
        border-radius: var(--inputs-radius) !important;
        box-sizing: border-box !important;
        min-height: var(--buttons-height) !important;
      }

      [class*="selectContainer" i] button[type="button"],
      [class*="selectContainer" i] [class*="selectToggle" i],
      [class*="selectContainer" i] [class*="selecttoggle" i],
      .phone-country-selector [class*="selectToggle" i],
      .phone-country-selector [class*="selecttoggle" i] {
        outline: none !important;
        box-shadow: none !important;
        color: var(--wim-color-black-grey) !important;
        background-color: transparent !important;
        border: 0 !important;
        border-radius: var(--inputs-radius) !important;
        line-height: calc(var(--buttons-height) - var(--inputs-border-width, 0px) * 2) !important;
        min-height: calc(var(--buttons-height) - var(--inputs-border-width, 0px) * 2) !important;
        padding: 0 1.2rem !important;
        box-sizing: border-box !important;
        width: 100% !important;
      }

      [class*="selectContainer" i] > [class*="label" i] {
        position: absolute !important;
        top: 0 !important;
        left: 1.6rem !important;
        transform: translateY(-50%) !important;
        font-size: var(--wim-font-size-paragraph-xs, 1.2rem) !important;
        font-weight: var(--wim-font-weight-bold) !important;
        background-color: #ffffff !important;
        background-color: rgb(var(--color-background)) !important;
        padding: 0 0.6rem !important;
        color: var(--wim-color-black-grey) !important;
        pointer-events: none !important;
        z-index: 2 !important;
      }

      textarea {
        border-radius: var(--textareas-radius) !important;
        min-height: 18rem;
        resize: vertical;
      }

      [data-wim-acceptance-heading] { display: none !important; }

      fieldset[name*="aceptacion" i] {
        grid-template-columns: 1fr !important;
        width: 100% !important;
        min-width: 0 !important;
      }
      fieldset[name*="aceptacion" i] label {
        display: flex !important;
        flex-direction: row !important;
        align-items: flex-start !important;
        column-gap: 0.8rem !important;
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
      }
      fieldset[name*="aceptacion" i] label input[type="checkbox"] {
        flex: 0 0 auto !important;
        margin-top: 0.15em !important;
      }

      fieldset[name*="aceptacion" i] span[class*="textBody" i] {
        font-size: var(--wim-font-size-paragraph-sm) !important;
        color: var(--wim-color-black-grey) !important;
        font-weight: var(--wim-font-weight-bold) !important;
        flex: 1 1 0% !important;
        min-width: 0 !important;
        max-width: 100% !important;
      }

      .wim-contact-form__legal,
      .wim-contact-form__legal a {
        color: rgb(var(--color-foreground)) !important;
      }

      button[type="submit"], [type="submit"] {
        --color-border: var(--color-button);
        background: rgb(var(--color-button)) !important;
        color: rgb(var(--color-button-text)) !important;
        border: var(--buttons-border-width) solid rgba(var(--color-border), var(--color-border-alpha, 1)) !important;
        width: 33% !important;
        font-family: var(--font-button-family) !important;
        font-weight: var(--font-button-weight) !important;
        filter: unset !important;
        border-radius: var(--buttons-radius, 0) !important;
      }

      button[type="submit"][disabled], [type="submit"][disabled] {
        opacity: .55;
        cursor: not-allowed;
      }

      @media (hover: hover) and (pointer: fine) {
        button[type="submit"]:not([disabled]):hover,
        [type="submit"]:not([disabled]):hover {
          background-color: var(--wim-color-blue-original) !important;
          border-color: var(--wim-color-blue-original) !important;
          color: var(--wim-color-yellow) !important;
        }
      }


      [data-wim-phone-container] {
        --wim-phone-country-width: 22%;
        display: grid !important;
        grid-template-columns: var(--wim-phone-country-width) 1fr !important;
        column-gap: 1.2rem !important;
        row-gap: .6rem !important;
        align-items: start !important;
        width: 100% !important;
        min-width: 0 !important;
      }

      [data-wim-phone-container] > label.wim-forms-label,
      [data-wim-phone-container] > label {
        grid-column: 1 / -1 !important;
      }

      [data-wim-phone-container] .phone-country-selector,
      [data-wim-phone-container] [class*="phone-country-selector" i] {
        width: 100% !important;
        grid-column: 1 !important;
        min-width: 0 !important;
      }

      [data-wim-phone-container] input[type="tel"],
      [data-wim-phone-container] input[autocomplete="tel"] {
        grid-column: 2 !important;
        width: 100% !important;
        min-width: 0 !important;
      }

      @media (max-width: 767.98px) {
        [data-wim-phone-container] { --wim-phone-country-width: 27%; }
      }

      [data-wim-phone-container] > label.wim-forms-label,
      [data-wim-phone-container] > label {
        font-size: var(--wim-font-size-paragraph-sm) !important;
        color: var(--wim-color-black-grey) !important;
        font-weight: var(--wim-font-weight-bold) !important;
        opacity: 1 !important;
        margin: 0 0 .6rem 0 !important;
      }

      [data-wim-phone-field] > label,
      [data-wim-phone-field] [class*="formInputFieldLabel" i],
      [data-wim-phone-field] [class*="_formInputFieldLabel" i] {
        display: block !important;
        width: 100% !important;
        justify-content: flex-start !important;
        text-align: left !important;
        white-space: normal !important;
      }

      [data-wim-motivo-field][data-wim-motivo-empty="true"] button,
      [data-wim-motivo-field][data-wim-motivo-empty="true"] [role="combobox"] {
        color: rgba(0,0,0,.55) !important;
      }

      [data-wim-motivo-title="true"] {
        font-size: var(--wim-font-size-paragraph-sm) !important;
        color: var(--wim-color-black-grey) !important;
        font-weight: var(--wim-font-weight-bold) !important;
        opacity: 1 !important;
        display: block !important;
        margin: 0 0 .35rem 0 !important;
        padding: 0 !important;
        text-align: left !important;
      }
    `;
    if (!existing) {
      target.appendChild(style);
    } else if (existing.getAttribute('data-wim-forms-skin-version') !== WIM_FORMS_VERSION) {
      existing.textContent = style.textContent;
      existing.setAttribute('data-wim-forms-skin-version', WIM_FORMS_VERSION);
    }
  }

  // Ocultar el campo Empresa si Shopify Forms lo agrega.
  function hideCompanyField(scope) {
    const companyInput =
      scope.querySelector('input[autocomplete="organization"]') ||
      scope.querySelector('input[name*="company" i]') ||
      scope.querySelector('input[placeholder="Company name" i]');
    if (!companyInput) return;
    companyInput.required = false;
    companyInput.removeAttribute('required');
    const companyWrapper = companyInput.closest('[class*="field"], [class*="form"], div');
    if (companyWrapper) companyWrapper.style.display = 'none';
  }

  // Encontrar el botón de enviar
  function findSubmitControl(scope) {
    return (
      scope.querySelector('button[type="submit"]') ||
      scope.querySelector('input[type="submit"]') ||
      scope.querySelector('[type="submit"]') ||
      Array.prototype.slice
        .call(scope.querySelectorAll('button, input'))
        .find((el) => {
          const t = (el.textContent || el.value || '').trim().toLowerCase();
          return t === 'enviar ahora' || t === 'submit';
        })
    );
  }

  // Mover el texto legal justo antes del submit.
  function placeLegalBeforeSubmit({ legal, submit, shadow }) {
    if (!legal || !submit || !submit.parentNode) return;
    if (shadow) {
      if (!shadow.querySelector('[data-wim-legal-clone]')) {
        const clone = document.createElement('div');
        clone.setAttribute('data-wim-legal-clone', 'true');
        clone.className = 'rte wim-contact-form__legal';
        clone.innerHTML = legal.innerHTML;
        submit.parentNode.insertBefore(clone, submit);
        legal.style.display = 'none';
      }
    } else {
      submit.parentNode.insertBefore(legal, submit);
    }
  }

  // Ocultar el título duplicado embebido.
  function hideDuplicateFormTitle(scope) {
    qsa(scope, 'h1,h2,h3,[role="heading"]').forEach((el) => {
      const t = normText(el.textContent).toLowerCase();
      if (t === 'buzón de sugerencias' || t === 'buzon de sugerencias') el.style.display = 'none';
    });
  }

  // Normalizar fields: label arriba, placeholders, y marcar contenedor de teléfono.
  function normalizeFormFieldWrappers(scope) {
    const wrappers = qsa(scope, '[class*="formFieldContainer" i]');
    wrappers.forEach((wrapper, idx) => {
      const txt = (wrapper.textContent || '').toLowerCase();
      if (txt.includes('he leído y acepto') || txt.includes('he leido y acepto')) return;

      const control = wrapper.querySelector('input, textarea, select, button');
      const label = wrapper.querySelector('label');
      if (!control || !label) return;

      wrapper.classList.add('wim-forms-field');
      wrapper.setAttribute('data-wim-field', wrapper.getAttribute('data-wim-field') || control.getAttribute('data-testid') || '');

      if (!control.id) control.id = `wim-forms-field-${idx + 1}`;
      label.setAttribute('for', control.id);
      label.removeAttribute('style');
      label.classList.add('wim-forms-label');
      try {
        wrapper.insertBefore(label, control);
      } catch (e) {}

      if ((control.tagName === 'INPUT' || control.tagName === 'TEXTAREA') && !control.getAttribute('placeholder')) {
        const labelText = (label.textContent || '').trim();
        if (labelText) control.setAttribute('placeholder', labelText);
      }

      if (control.tagName === 'TEXTAREA') control.setAttribute('placeholder', '');
      if (wrapper.querySelector('textarea')) wrapper.setAttribute('data-wim-span', '2');

      const isTel =
        (control.tagName === 'INPUT' && (control.getAttribute('type') || '').toLowerCase() === 'tel') ||
        (control.getAttribute('autocomplete') || '').toLowerCase() === 'tel' ||
        (label && (label.textContent || '').trim().toLowerCase().includes('teléfono')) ||
        (label && (label.textContent || '').trim().toLowerCase().includes('telefono'));
      if (!isTel) return;

      wrapper.setAttribute('data-wim-phone-field', 'true');
      const phoneContainer = wrapper.closest('[class*="formPhoneInputContainer" i]');
      const countrySelector =
        (phoneContainer && phoneContainer.querySelector && phoneContainer.querySelector('.phone-country-selector')) ||
        (phoneContainer && phoneContainer.querySelector && phoneContainer.querySelector('[class*="phone-country-selector" i]')) ||
        (phoneContainer && phoneContainer.querySelector && phoneContainer.querySelector('[class*="country-selector" i]'));

      if (!phoneContainer || !countrySelector) return;

      phoneContainer.setAttribute('data-wim-phone-container', 'true');
      try {
        const phoneLabel =
          wrapper.querySelector('label') ||
          wrapper.querySelector('[class*="formInputFieldLabel" i]') ||
          wrapper.querySelector('[class*="_formInputFieldLabel" i]');
        if (phoneLabel && !phoneLabel.hasAttribute('data-wim-phone-label')) {
          phoneLabel.setAttribute('data-wim-phone-label', 'true');
          phoneContainer.insertBefore(phoneLabel, phoneContainer.firstChild);
        }
      } catch (e) {}
    });
  }

  // Encontrar el contenedor del campo "Motivo de contacto".
  function findMotivoContainer(scope) {
    const labelNodes = qsa(scope, 'label, p, span');
    const labelEl = labelNodes.find(
      (el) => normText(el.textContent).toLowerCase() === 'motivo de contacto'
    );
    if (!labelEl) return null;

    const candidates = [];
    let cur = labelEl.parentElement;
    for (let i = 0; i < 6 && cur; i += 1) {
      candidates.push(cur);
      cur = cur.parentElement;
    }
    return (
      candidates.find((c) => c.querySelector && (c.querySelector('select') || c.querySelector('button'))) ||
      labelEl.parentElement
    );
  }

  // Motivo: subir el título arriba del dropdown.
  function hoistMotivoTitleOutOfSelectPill(container) {
    if (!container) return;
    if (container.getAttribute('data-wim-motivo-label-hoisted') === 'true') return;
    const title =
      Array.prototype.slice
        .call(container.querySelectorAll('p, label, span'))
        .find((el) => normText(el.textContent).toLowerCase() === 'motivo de contacto') || null;
    if (!title) return;
    if (title.getAttribute('data-wim-motivo-title') === 'true') return;
    if (title.parentNode !== container) return;
    try {
      title.setAttribute('data-wim-motivo-title', 'true');
      container.parentNode && container.parentNode.insertBefore(title, container);
      container.setAttribute('data-wim-motivo-label-hoisted', 'true');
    } catch (e) {}
  }

  // Deshabilitar submit hasta que el checkbox de aceptación esté marcado.
  function setupAcceptanceGating(scope, submit) {
    const acceptCheckbox = qsa(scope, 'input[type="checkbox"]').find((cb) => {
      const wrap = cb.closest('label') || cb.parentElement;
      let t = wrap ? (wrap.textContent || '') : '';
      t = t.toLowerCase();
      return (
        t.includes('he leído y acepto') ||
        t.includes('he leido y acepto') ||
        t.includes('política de privacidad') ||
        t.includes('politica de privacidad')
      );
    });

    if (!acceptCheckbox || !submit) return;

    const acceptanceHeading = qsa(scope, '*').find((el) => {
      if (!el || !el.textContent) return false;
      if (el.querySelector && el.querySelector('input[type="checkbox"]')) return false;
      const t = normText(el.textContent).toLowerCase();
      return t === 'aceptación legal' || t === 'aceptacion legal';
    });
    if (acceptanceHeading) acceptanceHeading.setAttribute('data-wim-acceptance-heading', 'true');

    const sync = () => {
      submit.disabled = !acceptCheckbox.checked;
    };
    acceptCheckbox.addEventListener('change', sync);
    sync();
  }

  // Validación requerida de Motivo para select custom (combobox/button).
  function applyMotivoCustom(container, scope, submit) {
    if (!container) return false;
    container.setAttribute('data-wim-motivo-field', 'true');
    if (container.getAttribute('data-wim-motivo-custom') === 'true') return true;

    const trigger =
      container.querySelector('button[aria-haspopup="listbox"]') ||
      container.querySelector('[role="combobox"]') ||
      container.querySelector('button');
    if (!trigger) return false;

    const getTriggerText = () => {
      const span =
        trigger.querySelector('[class*="selectToggleText" i]') ||
        trigger.querySelector('[class*="selecttoggletext" i]');
      const fromSpan = span ? normText(span.textContent) : '';
      if (fromSpan) return fromSpan;
      return normText(trigger.textContent);
    };
    const isEmpty = () => {
      const t = getTriggerText().toLowerCase();
      // En nuestro caso "Motivo" es un botón; consideramos vacío el estado inicial.
      return !t || t === 'seleccione un motivo' || t === 'motivo de contacto';
    };

    const syncEmptyAttr = () => {
      container.setAttribute('data-wim-motivo-empty', isEmpty() ? 'true' : 'false');
    };
    syncEmptyAttr();

    trigger.addEventListener('click', () => window.setTimeout(syncEmptyAttr, 0));
    trigger.addEventListener('blur', () => window.setTimeout(syncEmptyAttr, 0));

    const form = scope.querySelector('form') || (submit ? submit.closest('form') : null);
    if (form && form.getAttribute('data-wim-motivo-custom-submit') !== 'true') {
      form.setAttribute('data-wim-motivo-custom-submit', 'true');
      form.addEventListener('submit', (e) => {
        syncEmptyAttr();
        if (isEmpty()) {
          e.preventDefault();
          e.stopPropagation();
          try {
            trigger.setAttribute('aria-invalid', 'true');
            trigger.focus();
          } catch (err) {}
        }
      });
    }

    container.setAttribute('data-wim-motivo-custom', 'true');
    return true;
  }

  // Reintentar mejoras de Motivo (puede renderizar más tarde que el form base).
  function scheduleMotivoEnhancements(appRoot, scope, submit) {
    if (appRoot.dataset.wimMotivoScheduled === WIM_FORMS_VERSION) return;
    appRoot.dataset.wimMotivoScheduled = WIM_FORMS_VERSION;

    let tries = 0;
    const tick = () => {
      tries += 1;
      const mc = findMotivoContainer(scope);
      if (!mc) {
        if (tries < MOTIVO_MAX_TRIES) window.setTimeout(tick, MOTIVO_RETRY_MS);
        return;
      }

      hoistMotivoTitleOutOfSelectPill(mc);
      const ok = applyMotivoCustom(mc, scope, submit);
      if (!ok && tries < MOTIVO_MAX_TRIES) window.setTimeout(tick, MOTIVO_RETRY_MS);
    };
    tick();
  }

  // Inicializar una instancia de la sección (se llama hasta que Forms termine de renderizar y quede todo listo).
  function initOne(sectionRoot) {
    const appRoot = sectionRoot.querySelector('[data-wim-contact-form-app]');
    if (!appRoot) return;
    if (appRoot.dataset.wimFormsInit && appRoot.dataset.wimFormsInit !== WIM_FORMS_VERSION) {
      delete appRoot.dataset.wimFormsInit;
      delete appRoot.dataset.wimMotivoScheduled;
    }
    if (appRoot.dataset.wimFormsInit === WIM_FORMS_VERSION) return;

    const legal = sectionRoot.querySelector('[data-wim-contact-form-legal]');

    const host = getFormsHost(appRoot);
    const shadow = host && host.shadowRoot ? host.shadowRoot : null;
    const scope = shadow || appRoot;

    ensureSkinStyles(shadow || scope, shadow ? appRoot : null);
    hideCompanyField(scope);

    const submit = findSubmitControl(scope);
    if (!submit) return;

    placeLegalBeforeSubmit({ legal, submit, shadow });
    hideDuplicateFormTitle(scope);
    normalizeFormFieldWrappers(scope);
    setupAcceptanceGating(scope, submit);

    appRoot.dataset.wimFormsInit = WIM_FORMS_VERSION;
    scheduleMotivoEnhancements(appRoot, scope, submit);
  }

  // Inicializar todas las instancias del contact form en la página.
  function initAll() {
    document.querySelectorAll('[data-wim-contact-form-app]').forEach((app) => {
      const sectionRoot = app.closest('[id^="shopify-section-"]') || document;
      initOne(sectionRoot);
    });
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event && event.target ? event.target : null;
    if (!section || !section.querySelector) return;
    const app = section.querySelector('[data-wim-contact-form-app]');
    if (!app) return;
    delete app.dataset.wimFormsInit;
    delete app.dataset.wimMotivoScheduled;
    initOne(section);
  });

  // Polling acotado: máximo ~40s y se corta cuando ya está inicializado.
  let attempts = 0;
  (function retry() {
    attempts += 1;
    initAll();
    const apps = Array.prototype.slice.call(document.querySelectorAll('[data-wim-contact-form-app]'));
    const allDone = apps.length > 0 && apps.every((app) => app.dataset.wimFormsInit === WIM_FORMS_VERSION);
    if (allDone || attempts >= MAX_POLL_ATTEMPTS) return;
    window.setTimeout(retry, POLL_MS);
  })();

  document.addEventListener('shopify:section:select', initAll);
  document.addEventListener('shopify:block:select', initAll);
})();

